export default "__VITE_ASSET__Dx6b7iWJ__"